import { Button } from '@/components/ui/button';

type ActionButton = {
  label: string;
  icon: string;
  onClick: () => void;
};

interface ActionToastProps {
  actionButtons: ActionButton[];
}

export function ActionToast({ actionButtons }: ActionToastProps) {
  return (
    <div className="bg-fx-neutral-900/75 fixed bottom-10 left-1/2 -translate-x-1/2 rounded-lg px-4 py-2 shadow-lg">
      {actionButtons.map(button => (
        <Button
          key={button.label}
          variant="toast"
          size="sm"
          onClick={button.onClick}
        >
          <img src={button.icon} alt="Chart bar" />
          {button.label}
        </Button>
      ))}
    </div>
  );
}
